export const INITIAL_FORM_VALUE = {
  title: '',
  avatarBot: null,
  categories: [],
  functionalities: [],
  shortDescription: '',
  longDescription: '',
  published: false,
};

export const fieldValidations = {
  title: (value) => value.length > 0,
  avatarBot: (value) => !!value,
  categories: (value) => value.length > 0,
  functionalities: (value) =>
    value.map((v) => v.length > 0).filter(Boolean).length > 0,
  shortDescription: (value) => value.length > 0 && value.length <= 150,
  longDescription: (value) => value.length > 0 && value.length <= 650,
  published: (value) => typeof value !== 'undefined' && value !== null,
};
